import React from 'react'
import './JoyfullyBold/joyfully-bold-embedded-form.css'
import './JoyfullyBold/joyfully-bold-embedded-help-button-redesign.css'

const RedesignTheme = () => <React.Fragment></React.Fragment>

export default RedesignTheme
